// src/components/Header.tsx
import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import {
  TdsGlobalHeader,
  TdsButton,
} from '@trv-tds/react';
import { useAppDispatch } from '../../redux/hooks.js';
import { setCurrentRoute } from '../../redux/slices/headerSlice.js';
import { APP_STRINGS } from '../../constants/index.js';
import { useSession } from '../../contexts/SessionContext';

const Header: React.FC = () => {
  const location = useLocation();
  const dispatch = useAppDispatch();
  const { hasSession, session, logout } = useSession();

  // Update Redux state when location changes
  useEffect(() => {
    dispatch(setCurrentRoute(location.pathname));
  }, [location.pathname, dispatch]);


  // Determine the header product text based on the current route
  const getHeaderProductText = () => {
    if (location.pathname.includes('/trav-referral/property')) {
      return `${APP_STRINGS.APP_NAME} - property`;
    } else if (location.pathname.includes('/trav-referral/auto')) {
      return `${APP_STRINGS.APP_NAME} - auto`;
    }
    return APP_STRINGS.APP_NAME;
  };

  return (
    <TdsGlobalHeader
      homehref="/"
      product={getHeaderProductText()}
      mobileBelow="1280"
      onClick={(e) => {
          e.preventDefault();
      }}
    >
      {hasSession && session && !session.isLoggedOut && (
        <TdsButton slot="actions" size="small" onClick={logout} variant="secondary">Logout</TdsButton>
      )}
    </TdsGlobalHeader>
  );
};

export default Header;
